const supportsObjectFit = () => {
  const isClient = typeof document !== 'undefined'

  if (isClient) {
    return 'object-fit' in document.documentElement.style
  }
  return true
}

export default supportsObjectFit
